import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import BookingWidget from "./components/BookingWidget";
import Occasions from "./components/Occasions";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-screen" style={{ background: "#0a0a0a" }}>
      <Navbar />
      <Hero />
      <Services />
      <BookingWidget />
      <Occasions />
      <WhyUs />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
